import { render, staticRenderFns } from "./SuggestionListeMare.vue?vue&type=template&id=8194eae0&"
import script from "./SuggestionListeMare.vue?vue&type=script&lang=js&"
export * from "./SuggestionListeMare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports